import { defineComponent as _defineComponent } from 'vue'
import { Trade, AdminTrade, AmountType, PremiumPaymentType } from 'ah-api-gateways';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { formatDate } from 'ah-common-lib/src/helpers/time';
import { computed } from 'vue';
import OptionPaymentScheduleModal from 'ah-trades/src/components/modals/OptionPaymentScheduleModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeOptionsRowDetails',
  props: {
    trade: null
  },
  setup(__props: any) {

const props = __props as {
  /**
   * Trade focused and currently showing the details off
   *
   */
  trade: Trade | AdminTrade;
};



const sellCurrency = computed(() => {
  if (props.trade.ccy1.amountType === AmountType.SELL) {
    return props.trade.ccy1.currency;
  }
  return props.trade.ccy2.currency;
});

const buyCurrency = computed(() => {
  if (props.trade.ccy1.amountType === AmountType.BUY) {
    return props.trade.ccy1.currency;
  }
  return props.trade.ccy2.currency;
});

const sellAmount = computed(() => {
  if (props.trade.ccy1.amountType === AmountType.SELL) {
    return props.trade.ccy1.clientAmount;
  }
  return props.trade.ccy2.clientAmount;
});

const buyAmount = computed(() => {
  if (props.trade.ccy1.amountType === AmountType.BUY) {
    return props.trade.ccy1.clientAmount;
  }
  return props.trade.ccy2.clientAmount;
});

const premiumSettled = computed(() => {
  return props.trade.isPremiumPaid ? 'Yes' : 'No';
});

const isPremiumPaidMonthly = computed(() => props.trade.premiumPaymentType === PremiumPaymentType.MONTHLY);

return { __sfc: true,props, sellCurrency, buyCurrency, sellAmount, buyAmount, premiumSettled, isPremiumPaidMonthly, formatCurrencyValue, formatDate, OptionPaymentScheduleModal }
}

})